import { memo, useEffect, useMemo } from "react";

// Components
import TabPenta from "react-lib/frameworks/TabPenta";
import CardSpecimenSubmissionLogReportProps, {
  type CardSpecimenSubmissionLogReportProps as SpecimenReportProps,
} from "react-lib/apps/MEH/CardSpecimenSubmissionLogReport";

import { PickedState, State as ReportListSequence } from "react-lib/apps/MEH/sequence/MeReportList";

type CardReportListProps = {
  //
  runSequence: any;
  setProp: any;
  onEvent: any;
  errorMessage?: Record<string, any>;

  // data
  ReportListSequence?: ReportListSequence["ReportListSequence"];

  // Common
  languageUX: "en" | "th";
  selectedDivision: Record<string, any>;
  masterOptions?: Record<string, any[]>;
  masterData?: Record<string, any[]>;
} & Pick<PickedState, "buttonLoadCheck"> &
  Pick<SpecimenReportProps, "tableStyle" | "renderPagination">;

const CardMeReportList = (props: CardReportListProps) => {
  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        <TabPenta
          tabWidth="12%"
          activeStyle={{ backgroundColor: "var(--primary-theme-color-08)", color: "black" }}
          activeItemStyle={{
            filter: "brightness(0) invert(1)",
          }}
          data={[
            {
              key: "specimen_submission_log_report",
              name: (
                <div>
                  <label>รายงานบันทึกการส่งสิ่งส่งตรวจ</label>
                </div>
              ),
              render: () => (
                <CardSpecimenSubmissionLogReportProps
                  runSequence={props.runSequence}
                  setProp={props.setProp}
                  onEvent={props.onEvent}
                  buttonLoadCheck={props.buttonLoadCheck}
                  selectedDivision={props.selectedDivision}
                  ReportListSequence={props.ReportListSequence}
                  masterOptions={props.masterOptions}
                  languageUX={props.languageUX}
                  tableStyle={props.tableStyle}
                  renderPagination={props.renderPagination}
                />
              ),
            },
          ]}
        />
      </div>
    </>
  );
};

export default memo(CardMeReportList);
